var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVisa = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 24,
    viewBox: "0 0 91 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9513 1.38574H12.0906L12 1.8161C18.9119 3.58359 23.4894 7.84405 25.3702 12.9649L23.444 3.17612C23.1268 1.81579 22.1523 1.43061 20.9513 1.38574Z",
    fill: "#FAA61A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3528 1.38574L25.9594 15.908L25.37 12.9627C24.3729 9.56422 21.2457 5.87186 17.7559 4.03592L22.696 22.6597H28.5198L37.1763 1.38574H31.3528V1.38574Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7433 15.1377C69.1968 13.9142 70.942 9.17909 70.942 9.17909C70.9191 9.22455 71.3947 7.93304 71.6666 7.14019L72.0515 8.97523C72.0515 8.97523 73.0944 14.0729 73.3209 15.1377C72.4602 15.1377 69.8311 15.1377 68.7433 15.1377ZM75.5413 1.38574H71.2814C69.9678 1.38574 68.9698 1.77058 68.403 3.15273L60.2227 22.682H66.0013C66.0013 22.682 66.9526 20.0535 67.1571 19.4874C67.791 19.4874 73.4124 19.4874 74.228 19.4874C74.3861 20.2351 74.8851 22.682 74.8851 22.682H79.9843L75.5413 1.38574V1.38574Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4226 1.90668C60.3363 1.47577 58.6134 1 56.483 1C51.0444 1 47.2146 3.89981 47.1911 8.04566C47.146 11.1045 49.9332 12.8034 52.0178 13.8233C54.1485 14.8655 54.8727 15.5457 54.8727 16.4747C54.8511 17.9014 53.151 18.559 51.5654 18.559C49.3667 18.559 48.1886 18.22 46.3982 17.4262L45.673 17.086L44.9023 21.8666C46.194 22.455 48.5737 22.9771 51.0444 23C56.823 23 60.5851 20.1451 60.6297 15.727C60.6516 13.3027 59.1799 11.445 56.0069 9.92707C54.0807 8.95264 52.9011 8.29559 52.9011 7.29858C52.9237 6.3922 53.8988 5.46384 56.0732 5.46384C57.8635 5.41837 59.179 5.84867 60.1755 6.27928L60.6736 6.50542L61.4226 1.90668Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4604 22.6823H35.9531L39.3978 1.38574H44.9047L41.4604 22.6823Z",
    fill: "#00579F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisa, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Visa.24b8d4b2.svg";
export { ForwardRef as ReactComponent };